<template>
  <div>
    <nav data-gtm-context="Header" :class="['nav', 'nav-container', { 'nav--dark': theme === 'dark', 'nav--scrolled': isScrolled, 'nav--mobile-open': isMobileNavOpen }]">
      <div class="nav__links-container">
        <router-link to="/" data-gtm-ignore="true">
          <LogoFull
            class="nav__logo"
            :theme="theme == 'dark' ? 'white' : ''"
          ></LogoFull>
        </router-link>
        <ul class="nav__links mobile-nav-element">
          <li v-on:click="toggleMegaMenu('features', $event)" class="nav__link nav__link--features">
            <span class="nav__link-text">
              Product
              <span
                :class="[
                  'nav__link-arrow-container',
                  {
                    active: activeMenu === 'features',
                  },
                ]"
              >
                <Chevron class="nav__link-arrow"></Chevron>
              </span>
            </span>
            <FeaturesMenu 
              :class="{ 'mega-menu--show': activeMenu === 'features' }"
            />
          </li>

          <li>
            <router-link class="nav__link" to="/pricing/" title="Pricing">
              Pricing
            </router-link>
          </li>
          <li>
            <router-link
              class="nav__link"
              to="/integrations/"
              title="Integrations"
            >
              Integrations
            </router-link>
          </li>
          <li>
            <router-link class="nav__link" to="/emailtemplates/" title="Templates Gallery">
              Templates Gallery
            </router-link>
          </li>
          <li
            v-on:click="toggleMegaMenu('contentHub', $event)"
            class="nav__link nav__link--content-hub"
          >
            <span class="nav__link-text">
              Content Hub
              <span
                :class="[
                  'nav__link-arrow-container',
                  {
                    active: activeMenu === 'contentHub',
                  },
                ]"
              >
                <Chevron class="nav__link-arrow"></Chevron>
              </span>
            </span>
            <ContentHubMenu
              :class="{ 'mega-menu--show': activeMenu === 'contentHub' }"
            />
          </li>
          <li
            v-on:click="toggleMegaMenu('resources', $event)"
            class="nav__link nav__link--resources"
          >
            <span class="nav__link-text">
              Resources
              <span
                :class="[
                  'nav__link-arrow-container',
                  {
                    active: activeMenu === 'resources',
                  },
                ]"
              >
                <Chevron class="nav__link-arrow"></Chevron>
              </span>
            </span>
            <ResourcesMenu
              :class="{ 'mega-menu--show': activeMenu === 'resources' }"
            />
          </li>
          <span class="nav__secondary-links--mobile">
            <li v-if="!isPricingPage" class="nav__link--btn">
              <a
                href="/pricing/"
                class="btn btn--primary btn--sm nav__link--btn"
                title="Sign Up"
              >
                Get started
              </a>
            </li>
            <li>
              <a
                v-on:click="trackLogin"
                class="nav__link"
                title="Log in"
              >
                Log in
              </a>
            </li>
          </span>
        </ul>
        <div class="nav__links">
          <a
            class="btn btn--tertiary btn--sm"
            v-on:click="trackLogin"
            title="Log in"
          >
            Log in
          </a>
          <div v-if="!isPricingPage" class="nav__link">
            <a
              href="/pricing/"
              class="btn btn--primary btn--sm nav__link--btn"
              title="Sign Up"
            >
              Get started
            </a>
          </div>
        </div>
      </div>
      <div class="hamburger mobile-nav-element" v-on:click="toggleMobileNav()">
        <span class="hamburger__layer hamburger__layer--top"></span>
        <span class="hamburger__layer hamburger__layer--middle"></span>
        <span class="hamburger__layer hamburger__layer--bottom"></span>
      </div>
    </nav>

    <footer class="mobile-nav-element navigation__mobile-footer p-4">
      <div class="row between-sm">
        <div class="col-xs-12 col-sm-4 mb-4 sm:mb-0">
          <div class="row">
            <router-link class="footer__social-link" to="/terms/">
              <TwitterIcon class="footer__social-icon"></TwitterIcon>
            </router-link>
            <router-link class="footer__social-link" to="/terms/">
              <FacebookIcon class="footer__social-icon"></FacebookIcon>
            </router-link>
            <router-link class="footer__social-link" to="/terms/">
              <InstagramIcon class="footer__social-icon"></InstagramIcon>
            </router-link>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="row start-xs end-sm">
            <div class="footer__legal mb-4 mr-4 sm:mb-0">
              © 2022 Transpond. All Rights Reserved.
            </div>
            <div class="footer__legal-links">
              <router-link class="footer__legal-link" to="/terms/">
                Terms
              </router-link>
              <router-link class="footer__legal-link" to="/privacy/">
                Privacy
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FeaturesMenu from "@/components/navigation/megamenu/Features";
import ContentHubMenu from "@/components/navigation/megamenu/ContentHub";
import ResourcesMenu from "@/components/navigation/megamenu/Resources";
import LogoFull from "@/components/Svgs/Logo/LogoFull";
import Chevron from "@/components/Svgs/Icons/chevron";
import TwitterIcon from "../Svgs/TwitterIcon";
import FacebookIcon from "../Svgs/FacebookIcon";
import InstagramIcon from "../Svgs/InstagramIcon";
import TrackingHelpers from "@/functions/tracking";
import { gtmTracking } from "@/functions/gtm-tracking";

export default {
  name: "NavigationComponent",
  components: {
    LogoFull,
    Chevron,
    FeaturesMenu,
    ContentHubMenu,
    ResourcesMenu,
    TwitterIcon,
    FacebookIcon,
    InstagramIcon,
  },
  setup() {
    return {
      TrackingHelpers,
    };
  },

  props: {
    theme: {
      type: String,
    },
    announcementText: {
      type: String,
    },
    announcementLink: {
      type: Array,
    },
    announcementIcon: {
      type: String,
    },
  },
  data() {
    return {
      activeMenu: "",
      activeMobileNavElements: [],
      isScrolled: false,
      isMobileNavOpen: false,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  computed: {
    isAIPage() {
      return this.$route.path === "/ai-content-assistant";
    },
    isPricingPage() {
      return this.$route.path === "/pricing";
    },
  },

  methods: {
    trackLogin() {
      gtmTracking("Top Nav Click", "Log in", "")();
      TrackingHelpers.linkToApp();
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    resetMenuState() {
      this.activeMenu = "";
      if (this.activeMobileNavElements) {
        this.activeMobileNavElements.forEach((elem) =>
          elem.classList.remove("active")
        );
      }
    },
    toggleMegaMenu(menu) {
      if (this.activeMenu === menu) {
        this.activeMenu = "";
      } else {
        this.activeMenu = menu;
      }
    },

    //Mobile navigation
    setActiveMobileNavElements() {
      this.activeMobileNavElements = Array.from(
        document.getElementsByClassName("mobile-nav-element")
      );
    },
    toggleMobileNav() {
      this.activeMenu = "";
      this.isMobileNavOpen = !this.isMobileNavOpen;
      this.setActiveMobileNavElements();
      this.activeMobileNavElements.forEach((elem) =>
        elem.classList.toggle("active")
      );
    },
  },
};
</script>
